import { cx } from '@linaria/atomic';
import { XIconSmall } from '../../../icon/icons-small/x-small';
import { IconButton } from '../../icon-button/icon-button.component';
import type { FieldHandlers } from '../hooks/types';
import { clearFieldBtn } from './clear-field-btn.styles';

type Props = Omit<FieldHandlers<HTMLAnchorElement | HTMLButtonElement>, 'onChange'> & {
  onClick: () => void;
  className?: string;
};

export const ClearFieldBtn = ({ className, ...props }: Props) => {
  return (
    <IconButton size='small' label='Clear field' className={cx(clearFieldBtn, className)} {...props}>
      <XIconSmall />
    </IconButton>
  );
};
